// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skill_skill__3kcUX","skill__item":"Skill_skill__item__1OpOK","skill__item__icon":"Skill_skill__item__icon__uCmcT","skill__item__title":"Skill_skill__item__title__1sDE7"};